import * as React from 'react';
import { Button, Form, Header, Image, Segment, GridRow } from 'semantic-ui-react';
import configs from '../helpers/config';
import { showMessage } from '../helpers/helper';

class LoginTokenPaciente extends React.Component {
    constructor(props) {
        super(props);
        this.state = { token: this.props.Token, documento: '' };
    }
    
    handleLogin() {
        const { documento } = this.state;

        if (documento) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosLoginTokenPaciente' }).then(token => {
                    this.setState({ recaptcha_token: token });
                    this.props.onClick({ token: this.props.Token, documento: this.state.documento });
                });
            });
        } else {
            showMessage('Informe o documento de identificação do paciente');
        }
    }

    render() {
        return (
            <Segment className={this.props.className}>
                <Header as='h2'  >
                    <p className='headerLogin' ><Image src={require('../img/paciente.png')} size='small' verticalAlign='middle' className='imgLogoLogin' />PACIENTE</p>
                </Header>
                <Form size='large'>
                    <GridRow >
                        <Form.Input
                            fluid
                            icon='user'
                            iconPosition='left'
                            placeholder='Documento do paciente'
                            value={this.state.documento}
                            onChange={(e) => this.setState({ ...this.state, documento: e.target.value })}
                        />

                        <Button fluid size='large' onClick={() => this.handleLogin()}>
                            CONSULTAR RESULTADOS
                        </Button >
                    </GridRow>
                </Form>
            </Segment>
        );
    }
}
export default LoginTokenPaciente;
